//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.SpineDefinitionBuilder.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[1,"AngleLaw",0,"GeometricUtilities.LawBuilder",0],[0,"AngleTolerance",1,0],[1,"BaseProfile",0,"Section",0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[0,"DistanceTolerance",1,0],[1,"Faces",0,"ScCollector",0],[0,"IsAngleCorrected",1,0],[0,"IsReferenceFaceNormalReversed",1,0],[0,"LaydownCurve",1,0],[1,"LengthLaw",0,"GeometricUtilities.LawBuilder",0],[1,"MaxCorrectionAngle",0,"Expression",0],[0,"MergeFacesIfPossible",1,0],[0,"MiterOption",1,0],[1,"MiterRadius",0,"Expression",0],[0,"OppositeSideExtensionOption",1,0],[1,"OppositeSideLengthLaw",0,"GeometricUtilities.LawBuilder",0],[1,"SpineDefinition",0,"GeometricUtilities.SpineDefinitionBuilder",0],[0,"Type",1,0],[0,"Vector",1,"Direction",0]],[],[]];
SPLM.Features.LawExtensionBuilderEx = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.LawExtensionBuilderEx";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.LawExtensionBuilderEx.Types = Object.freeze({
    "Faces" : "Faces", "Vector" : "Vector"});

SPLM.Features.LawExtensionBuilderEx.OppositeSideExtensionOptions = Object.freeze({
    "None" : "None", "Symmetric" : "Symmetric", "Asymmetric" : "Asymmetric"});

SPLM.Features.LawExtensionBuilderEx.MiterOptions = Object.freeze({
    "None" : "None", "Sharp" : "Sharp", "Blend" : "Blend", "Radius" : "Radius"});

export default SPLM;